import { LitElement } from 'lit';

import { ConfigurationPrintOptionPersonalizationDto } from '@/api-sdk';
import { PersonalisationType, personalisation as pers } from '@/context';
import { ConfigurationService } from './utils.api';

/**
 * Fetches and processes personalisation data for a given element and UUID.
 *
 * This function retrieves personalisation data from the ConfigurationService
 * using the provided UUID. It then processes the data and triggers an update
 * event on the given element with the personalisation details.
 *
 * @param element - The LitElement instance to update with personalisation data.
 * @param uuid - The UUID used to fetch the personalisation data.
 * @returns A promise that resolves to the personalisation data or undefined if no data is found.
 */
export const getPersonalisationData = async (
  element: LitElement,
  uuid: string,
): Promise<PersonalisationType | undefined> => {
  const ConfigurationPersonalizationsPromise =
    ConfigurationService.getShowConfigurationPersonalizations({
      uuid: uuid,
    });

  const personalisation = await ConfigurationPersonalizationsPromise,
    personalisationData: ConfigurationPrintOptionPersonalizationDto[] =
      personalisation;

  if (!personalisationData) {
    return undefined;
  }

  personalisationData.map(personalisation => {
    const personalisationData = personalisation.personalization;

    pers.providerUpdateEvent(element, {
      printOptionCode: personalisation?.printOptionCode,
      type: personalisationData?.type,
      textPersonalization: personalisationData?.textPersonalization,
      uploadedFileName: personalisationData?.logo,
      colors: personalisationData?.colors,
      logoUuid: personalisationData?.logoUuid,
    });
  });
};
